import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: "'Inter', sans-serif", // Default font for body text
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "'Inter', sans-serif", // Set Inter globally for all Typography components
        },
      },
      variants: [
        {
          props: { variant: "h1" },
          style: { fontFamily: "'Poppins', sans-serif" },
        },
        {
          props: { variant: "h2" },
          style: { fontFamily: "'Poppins', sans-serif" },
        },
        {
          props: { variant: "h3" },
          style: { fontFamily: "'Poppins', sans-serif" },
        },
        {
          props: { variant: "h4" },
          style: { fontFamily: "'Poppins', sans-serif" },
        },
        {
          props: { variant: "h5" },
          style: { fontFamily: "'Poppins', sans-serif" },
        },
        {
          props: { variant: "h6" },
          style: { fontFamily: "'Poppins', sans-serif" },
        },
      ],
    },
  },
});

export default theme;
